import { Route, Routes, Navigate} from "react-router-dom";
import About from "../about/About";
import Contact from "../contact/Contact";
import Home from "../home/Home";
import Layout from "../layout/Layout";
import Gallery from "../gallery/Gallery";
import Services from "../services/Services";
import CurriculumVitae from "../cv/CurriculumVitae";
import PdfRedirect from "../../hooks/usePdfRedirect";

const Router = () => {

    return (
            <Routes>
                <Route path="/" element={<Layout/>}>
                    <Route index element={<Home />} />
                    <Route path="about" element={<About />} />
                    <Route path="contact" element={<Contact />} />
                    <Route path="gallery" element={<Gallery />} />
                    <Route path="services" element={<Services />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
            </Routes>   
    );

}
export default Router;
